export const EMAIL_REGEX = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})$/i
);

// No "g" flag: a global-flag regex is stateful (advances lastIndex across
// calls to .test()), so reusing this module-level instance would alternate
// true/false on repeated calls with the same input.
export const PHONE_REGEX = new RegExp(
  /((?:\+|00)[17](?: |-)?|(?:\+|00)[1-9]\d{0,2}(?: |-)?|(?:\+|00)1-\d{3}(?: |-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |-)[0-9]{3}(?: |-)[0-9]{4})|([0-9]{7}))/
);

export const VAT_REGEX = new RegExp(/^\d{11,13}$/);

export const PASSWORD_REGEX = new RegExp(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.!@#$%^&*])(?=.{8,})/
);

export const iphone = navigator.userAgent.includes("iPhone");
